import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import Component from 'flarum/common/Component';
import LoadingIndicator from 'flarum/common/components/LoadingIndicator';
export default class LogInView extends Component {
  constructor() {
    super(...arguments);
    _defineProperty(this, "loading", true);
    _defineProperty(this, "LogInSection", void 0);
  }
  oninit(vnode) {
    super.oninit(vnode);
    flarum.reg.asyncModuleImport('flarum/forum/components/LogInModal').then(() => import(/* webpackChunkName: 'forum/components/LogInSection', webpackMode: 'lazy-once' */ './LogInSection').then(LogInSection => {
      this.LogInSection = LogInSection.default;
      this.loading = false;
      m.redraw();
    }));
  }
  view() {
    if (this.loading) {
      return m(LoadingIndicator, null);
    }
    const LogInSection = this.LogInSection;
    return m(LogInSection, {
      routeSwitcher: this.attrs.routeSwitcher,
      animateShow: () => null
    });
  }
}
flarum.reg.add('sycho-private-facade', 'forum/components/LogInView', LogInView);flarum.reg.addChunkModule('556', '908', 'sycho-private-facade', 'forum/components/LogInSection');
flarum.reg.addChunkModule('556', '908', 'sycho-private-facade', 'forum/utils/mapChildren');